'use strict'

import Vue from 'vue'
import VueRouter from 'vue-router'

import Donaciones from './donaciones'
import ConfirmacionPagos from './confirmacionPagos'
import PagosEnLinea from './pagosEnLinea'
import PageNotFound from '../pageNotFound'
import { afterEach, defaultFrontofficeRoute, translateRoute } from '../routeUtility'

/**
 * File to configuration all frontoffice routes of the application
 *
 * @author C Camilo Castellanos
 * @author Oscar Paredes
 * @version 1.0.0
 * @since 19/12/2019 10:24 p. m.
 */

const routes = [
  Donaciones,
  PagosEnLinea,
  ConfirmacionPagos,
  PageNotFound,
  defaultFrontofficeRoute
].map(translateRoute)

Vue.use(VueRouter)

/* Configure router */
const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes
})

router.afterEach(afterEach)

export default router
